import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";
import { ISSUE_OPERATOR_ACTION } from "../../issue-operator-action";

/**
 * A backup or copy JOB failed — the early warning for both codes above.
 *
 * ONE CODE FOR BOTH JOB KINDS, unlike the two staleness codes, and the
 * asymmetry is deliberate. The staleness codes answer different questions
 * about the ARTIFACT ("is it there" vs "is it there too"), and an operator
 * acts on each differently. A failed job of either kind asks the same next
 * question — read the job's status message — so splitting it would produce two
 * alarms with one investigation. The payload names which kind it was.
 *
 * It fires the day something breaks, where a staleness alarm cannot appear
 * until the last good point ages past the RPO threshold. For a daily plan
 * that is more than a day of warning thrown away.
 */
export const VIBE_TENANT_BACKUP_JOB_FAILING = {
  category: ISSUE_CATEGORY.OBSERVABILITY,
  message:
    "The most recent AWS Backup job for this tenant's Forgejo git-repo volume failed — either the backup into its own-region vault or the cross-region copy out of it; the issue payload says which, and carries AWS's own status message. Separate from the two staleness alarms on purpose: this fires the day the job breaks, while a stale recovery point only becomes visible once the last good one ages past the RPO threshold, which for a nightly plan throws away more than a day of warning. Cleared once a job of that kind succeeds.",
  severity: "high",
  remedy:
    "Run the backup now to retry. Read the payload's status message first — an IAM or vault-lock misconfiguration will fail the same way again immediately, and needs fixing in AWS before retrying helps.",
  operatorAction: ISSUE_OPERATOR_ACTION.VIBE_RUN_TENANT_BACKUP_NOW
} as const satisfies IssueDefinition;
